export default "__VITE_ASSET__DcBwXdAY__"